define([
        "dojo/_base/lang",
        "../../../constants/TypeConstants",
        "../properties/TypeProperty",
        "../properties/TagProperty",
        "../properties/DisplayStateProperty",
        "../properties/SelectedProperty",
        "../properties/IconProperty",
        "../properties/IconOverrideProperty",
        "../properties/TextProperty",
        "../properties/TextOverrideProperty",
        "../properties/EnabledProperty",
        "../properties/DescriptionProperty",
        "../properties/DescriptionOverrideProperty",
        "../properties/MnemonicProperty",
        "../properties/ShortcutProperty",
        "../properties/ActionIdProperty",
        "../properties/AnimationProperty",
        "../properties/ButtonGroupNameProperty",
        "../properties/ClosePopupOnClickProperty",
        "../properties/RemovableProperty",
        "../properties/RemoveMessageProperty",
        "../properties/AllowDeselectionInButtonGroupProperty",
        "../properties/IsInQABProperty",
        "../properties/QuickAccessIconProperty"
    ],
    function (lang, TypeConstants, TypeProperty, TagProperty, DisplayStateProperty, SelectedProperty, IconProperty, IconOverrideProperty,
              TextProperty, TextOverrideProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty,
              MnemonicProperty, ShortcutProperty, ActionIdProperty, AnimationProperty, ButtonGroupNameProperty,
              ClosePopupOnClickProperty, RemovableProperty, RemoveMessageProperty, AllowDeselectionInButtonGroupProperty,
              IsInQABProperty, QuickAccessIconProperty) {
        var hash = {};
        hash[TypeConstants.TOGGLE_GALLERY_ITEM] = lang.clone(lang.mixin({}, {
                isFavorite: {
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                }
            }, TypeProperty, TagProperty, DisplayStateProperty, SelectedProperty, IconProperty, IconOverrideProperty,
            TextProperty, TextOverrideProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty,
            MnemonicProperty, ShortcutProperty, ActionIdProperty, AnimationProperty, ButtonGroupNameProperty,
            ClosePopupOnClickProperty, RemovableProperty, RemoveMessageProperty, AllowDeselectionInButtonGroupProperty,
            IsInQABProperty, QuickAccessIconProperty));

        hash[TypeConstants.TOGGLE_GALLERY_ITEM] = JSON.parse(JSON.stringify(hash[TypeConstants.TOGGLE_GALLERY_ITEM]));
        hash[TypeConstants.TOGGLE_GALLERY_ITEM].closePopupOnClick.defaultValue = true;

        return hash;
    });

